import {  GET_DIVISION_DETAIL_ADMINTOOLS, GET_DIVISION_OPTIONS, RESET_DIVISION_DETAIL_ADMINTOOLS} from "shared/constants/ActionTypes";

const initialState = {
  dataTitle: null,
  detailDivision:null,
  optionsDivision:null
};

const divisonAdmintoolsReducer = (state = initialState, action) => {
  switch (action.type) {
  
      case GET_DIVISION_DETAIL_ADMINTOOLS:
        return {
          ...state,
          detailDivision: action.payload,
        };
        case GET_DIVISION_OPTIONS :
          return {
            ...state,
            optionsDivision: action.payload,
          };
        default: {
          return state;
        }

        case RESET_DIVISION_DETAIL_ADMINTOOLS:
          return initialState
  }
};

export default divisonAdmintoolsReducer;
